import { Controller } from "@hotwired/stimulus";

// Auto-dismisses flash messages after a configurable delay
export default class extends Controller {
  static values = { dismissAfter: { type: Number, default: 5000 } };

  connect() {
    if (this.dismissAfterValue > 0) {
      this._timeout = setTimeout(() => this.dismiss(), this.dismissAfterValue);
    }
  }

  disconnect() {
    this._clearTimeout();
  }

  dismiss() {
    this._clearTimeout();
    this.element.remove();
  }

  // Private

  _clearTimeout() {
    if (this._timeout) {
      clearTimeout(this._timeout);
      this._timeout = null;
    }
  }
}
